<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item" *ngIf="role.dpa_button_newcase">
      <a class="nav-link action-menu" (click)="newCase($event)">New Case</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_reaasigncase">
      <a class="nav-link action-menu" (click)="forward($event)">Forward</a>
    </li>
    <li class="nav-item" *ngIf="role.dpa_button_cancelcase">
      <a class="nav-link action-menu" (click)="delete($event)">Cancel</a>
    </li>
  </ul>
  <form class="form-inline">
    <!-- <input class="form-control filter" type="search" placeholder="Search"> -->
  </form>
</nav>

<div class="row">
  <div class="col-6">

    <div class="row mt-3">
      <div class="col-12 p-0">
        <p class="mb-0">
          <button class="btn btn-primary collapsible" type="button" data-toggle="collapse" data-target="#caseCriteria" aria-expanded="false" aria-controls="caseCriteria">
            ค้นหา
            <i class="fa" aria-hidden="true"></i>
          </button>
        </p>
        <div class="collapse" id="caseCriteria">
          <div class="card card-body">
            <div class="row">
              <div class="col-2 text-right">
                <label>Case Id:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="caseNoMy">
              </div>

              <div class="col-2 text-right">
                <label>ชื่อ:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="firstnameMy">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>เบอร์โทร:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control number" [(ngModel)]="telephoneMy">
              </div>

              <div class="col-2 text-right">
                <label>นามสกุล:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="lastnameMy">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>ประเภทรายงานการติดต่อ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="caseTypeMy" (change)="onCaseTypeMyChange()">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>

              <div class="col-2 text-right">
                <label>หัวข้อการติดต่อ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="caseSubTypeMy" (change)="onCaseSubTypeMyChange()">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseSubTypeMyList" [value]="c.dpa_casesubtypeid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>หัวข้อย่อย:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="subTypeDetailMy">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseSubTypeDetailMyList" [value]="c.dpa_casesubtypedetailid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>

              <div class="col-2 text-right">
                <label>สถานะ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="statusMy">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>วันที่:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateFromMy" />
              </div>

              <div class="col-2 text-right">
                <label>ถึงวันที่:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateToMy" />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 text-center">
                <button class="btn btn-primary m-2" (click)="searchMyCase()">
                  ค้นหา
                  <span class="fa fa-search"></span>
                </button>
                <button class="btn btn-default m-2" (click)="resetSearchMyCase()">
                  ล้างค่า
                  <span class="fa fa-times"></span>
                </button>
              </div>
            </div>
        </div>
        </div>
      </div>
    </div>

    <div class="card card-default ">
      <div class="card-header">
        <div class="row">
          <div class="col-8 my-auto">
            <h3 class="card-title font-cust-blue">My Case</h3>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 text-center">
                <span class="dot high"></span>
                <label class="high">{{myCaseHigh}}</label>
                <br>
                <label class="high">High</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot medium"></span>
                <label class="medium">{{myCaseMedium}}</label>
                <br>
                <label class="medium">Medium</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot low"></span>
                <label class="low">{{myCaseLow}}</label>
                <br>
                <label class="low">Low</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body table-responsive">
        <table #tbMy id="tbMyCase" style="width:100%" class="table table-bordered table-hover result-table">
          <thead>
            <tr>
              <th class="checkbox-col">
                <input type="checkbox" [(ngModel)]="isCheckedAll" (change)="onCheckAllChange()">
              </th>
              <th>Priority</th>
              <th>Case ID</th>
              <th>Case Sub Type</th>
              <th>Contact</th>
              <th>Origin Source</th>
              <th>Status</th>
              <th>Date</th>
              <th>SLA</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let c of myCaseList; let i = index" id="{{c.ticketnumber}}">
              <td align="center" class="checkbox-col">
                <input type="checkbox" class="row-checker" value="{{c.incidentid}}" name="{{c.customerid}}">
              </td>
              <td align="center">
                <span class="{{'dot ' + c.dpa_caseseverityidname | lowercase}}"></span>
              </td>
              <td class="col-id">{{c.ticketnumber}}</td>
              <td>{{c.dpa_casesubtypeidname}}</td>
              <td>{{c.customeridname}}</td>
              <td>{{c.dpa_casechannelidname}}</td>
              <td class="status">{{c.dpa_casestatusidname}}</td>
              <td>{{c.createdon | thaidate: 'shortWithTime'}}</td>
              <td align="center" class="high">{{c.dpa_issla ? 'Over': ''}}</td>
              <td>{{c.dpa_slatime | thaidate: 'shortWithTime'}}</td>
            </tr> -->
          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div class="col-6">
    <div class="row mt-3">
      <div class="col-12 p-0">
        <p class="mb-0">
          <button class="btn btn-primary collapsible" type="button" data-toggle="collapse" data-target="#followCaseCritetia" aria-expanded="false" aria-controls="followCaseCritetia">
            ค้นหา
            <i class="fa" aria-hidden="true"></i>
          </button>
        </p>
        <div class="collapse" id="followCaseCritetia">
          <div class="card card-body">
            <div class="row">
              <div class="col-2 text-right">
                <label>Case Id:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="caseNoFollow">
              </div>

              <div class="col-2 text-right">
                <label>ชื่อ:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="firstnameFollow">
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>เบอร์โทร:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control number" [(ngModel)]="telephoneFollow">
              </div>

              <div class="col-2 text-right">
                <label>นามสกุล:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" [(ngModel)]="lastnameFollow">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>ประเภทรายงานการติดต่อ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="caseTypeFollow" (change)="onCaseTypeFollowChange()">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>

              <div class="col-2 text-right">
                <label>หัวข้อการติดต่อ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="caseSubTypeFollow" (change)="onCaseSubTypeFollowChange()">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseSubTypeFollowList" [value]="c.dpa_casesubtypeid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>หัวข้อย่อย:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="subTypeDetailFollow">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseSubTypeDetailFollowList" [value]="c.dpa_casesubtypedetailid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>

              <div class="col-2 text-right">
                <label>สถานะ:</label>
              </div>
              <div class="col-4">
                <select class="form-control" [(ngModel)]="statusFollow">
                  <option selected value="">กรุณาเลือก</option>
                  <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
                    {{c.dpa_name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>วันที่:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateFromFollow" />
              </div>

              <div class="col-2 text-right">
                <label>ถึงวันที่:</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateToFollow" />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 text-center">
                <button class="btn btn-primary m-2" (click)="searchFollowCase()">
                  ค้นหา
                  <span class="fa fa-search"></span>
                </button>
                <button class="btn btn-default m-2" (click)="resetSearchFollowCase()">
                  ล้างค่า
                  <span class="fa fa-times"></span>
                </button>
              </div>
            </div>
        </div>
        </div>
      </div>
    </div>

    <div class="card card-default">
      <div class="card-header">
        <div class="row">
          <div class="col-8 my-auto">
            <h3 class="card-title font-cust-blue">Follow Up Case</h3>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 text-center">
                <span class="dot high"></span>
                <label class="high">{{followCaseHigh}}</label>
                <br>
                <label class="high">High</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot medium"></span>
                <label class="medium">{{followCaseMedium}}</label>
                <br>
                <label class="medium">Medium</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot low"></span>
                <label class="low">{{followCaseLow}}</label>
                <br>
                <label class="low">Low</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body table-responsive">
        <table #tbFollow id="tbFollowCase" style="width:100%" class="table table-bordered table-hover result-table">
          <thead>
            <tr>
              <th>Priority</th>
              <th>Case ID</th>
              <th>Case Sub Type</th>
              <th>Contact</th>
              <th>Origin Source</th>
              <th>Status</th>
              <th>Date</th>
              <th>SLA</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let c of followCaseList; let i = index" id="{{c.ticketnumber}}">
              <td align="center">
                <span class="{{'dot ' + c.dpa_caseseverityidname | lowercase}}"></span>
              </td>
              <td class="col-id">{{c.ticketnumber}}</td>
              <td>{{c.dpa_casesubtypeidname}}</td>
              <td>{{c.customeridname}}</td>
              <td>{{c.dpa_casechannelidname}}</td>
              <td>{{c.dpa_casestatusidname}}</td>
              <td>{{c.createdon | thaidate: 'shortWithTime'}}</td>
              <td align="center" class="high">{{c.dpa_issla ? 'Over': ''}}</td>
              <td>{{c.dpa_slatime | thaidate: 'shortWithTime'}}</td>
            </tr> -->
          </tbody>
        </table>
      </div>

    </div>

  </div>
</div>


<!-- Modal Forward-->
<div class="modal fade" id="forwardModal" tabindex="-1" role="dialog" aria-labelledby="forwardModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="forwardModalLabel">ส่งต่อรายงานการติดต่อ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">ทีม</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="forwardTeam" (change)="onForwardTeamChange()">
              <option value="" selected>เลือก</option>
              <option *ngFor="let t of teamList" [value]="t.dpa_callcenterteamid">
                {{t.dpa_name}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedForward && forwardTeam == ''">
              กรุณาเลือก ทีม
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="">ผู้ใช้งาน</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="userIdReceive">
              <option value="">เลือก</option>
              <option *ngFor="let a of userList" [value]="a.dpa_customwebuserid">
                {{a.dpa_name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="required">หมายเหตุ</label>
          </div>
          <div class="col-7">
            <input type="text" class="form-control" [(ngModel)]="forwardRemark">
            <span class="text-danger" *ngIf="submittedForward && forwardRemark == ''">
              กรุณาระบุ หมายเหตุ
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmForward()">OK</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('forwardModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Delete-->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="deleteModalLabel">ยืนยัน ยกเลิก Case</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-3 text-right">
            <label class="required">เหตุผล:</label>
          </div>

          <div class="col-9">
            <textarea class="form-control" rows="3" [(ngModel)]="cancelRemark"></textarea>
            <span class="text-danger" *ngIf="submittedCancel && cancelRemark.trim().length == 0">
              กรุณาระบุเหตุผลในการยกเลิก
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmDelete()">ยืนยัน</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('deleteModal')">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case/case.component.html